/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_NewInputs */

const en_cases_new = /** @type {(inputs: Cases_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New case`)
};

const pt_br2_cases_new = /** @type {(inputs: Cases_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo caso`)
};

/**
* | output |
* | --- |
* | "New case" |
*
* @param {Cases_NewInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_new = /** @type {((inputs?: Cases_NewInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_NewInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_new(inputs)
	return pt_br2_cases_new(inputs)
});